import React from "react";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import socket from "../../assets/socketConnection";
import {
  setAlertPageFirstBtn,
  setAlertPageFirstBtnFunc,
  setAlertPageMessage,
  setAlertPageSecondBtn,
  toggleAlertPageIsVisible,
} from "../../redux/alertPage/alertPage.actions";
import { selectCurrentReqInfo } from "../../redux/currentReq/currentReq.selectors";

const ReqOptionsStatus2 = ({
  selectCurrentReqInfo,
  setAlertPageFirstBtnFunc,
  setAlertPageMessage,
  toggleAlertPageIsVisible,

  setAlertPageSecondBtn,
  setAlertPageFirstBtn,
}) => {
  const handle_cancelTwo_click = () => {
    setAlertPageFirstBtnFunc(() => {
      socket.emit("member_cancel_agreement_request", {
        load_id: selectCurrentReqInfo.id,
      });
    });
    // debugger;
    setAlertPageMessage("آیا از لغو توافقی مطمئنید؟");
    setAlertPageSecondBtn("خیر");
    setAlertPageFirstBtn("بله");
    toggleAlertPageIsVisible();
  };
  const handle_cancelOne_click = () => {
    setAlertPageFirstBtnFunc(() => {
      socket.emit("member_cancel_load", {
        load_id: selectCurrentReqInfo.id,
        reason: "دلخواه",
      });
    });
    // debugger;
    setAlertPageMessage("آیا از لغو یک‌طرفه مطمئنید؟");
    setAlertPageSecondBtn("خیر");
    setAlertPageFirstBtn("بله");
    toggleAlertPageIsVisible();
  };

  return (
    <div className="d-flex align-items-center justify-content-between w-100">
      <div className="d-flex align-text-center">
        <button
          onClick={handle_cancelTwo_click}
          className="req-options_btn req-options_btn--red"
        >
          لغو توافقی
        </button>

        <button
          onClick={handle_cancelOne_click}
          className="req-options_btn req-options_btn--red"
        >
          لغو یک‌طرفه
        </button>
      </div>
      <button className="req-options_btn req-options_btn--blue">
        پرداخت آنلاین به همراه جایزه
      </button>
    </div>
  );
};

const mapStateToProps = createStructuredSelector({
  selectCurrentReqInfo: selectCurrentReqInfo,
});

const mapDispatchToProps = (dispatch) => ({
  setAlertPageFirstBtnFunc: (x) => dispatch(setAlertPageFirstBtnFunc(x)),
  setAlertPageMessage: (x) => dispatch(setAlertPageMessage(x)),
  toggleAlertPageIsVisible: (x) => dispatch(toggleAlertPageIsVisible(x)),
  setAlertPageFirstBtn: (x) => dispatch(setAlertPageFirstBtn(x)),
  setAlertPageSecondBtn: (x) => dispatch(setAlertPageSecondBtn(x)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ReqOptionsStatus2);
